import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux'
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination, Navigation } from 'swiper/core';
import VideoBlock from '../videoBlock/videoBlock.component';

import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import "./videoGalleryComponent.css";
import { useEffect } from 'react';
// import { videos } from "../../data/videos";

// install Swiper modules
SwiperCore.use([Autoplay, EffectCoverflow, Pagination, Navigation]);

const VideoGallery = () => {

    const [allVideos, setAllVideos] = useState(null)
    const { laoding, videos } = useSelector(state => state.all)

    useEffect(() => {
        if (videos && videos.length > 0) {
            setAllVideos(videos)
        }
    }, [videos])
    // const [currentImage, setCurrentImage] = useState(0);
    // const [viewerIsOpen, setViewerIsOpen] = useState(false);

    // const openLightbox = useCallback((event, { photo, index }) => {
    //     setCurrentImage(index);
    //     setViewerIsOpen(true);
    // }, []);

    // const closeLightbox = () => {
    //     setCurrentImage(0);
    //     setViewerIsOpen(false);
    // };

    return (
        (!!allVideos && allVideos.length > 0) ?
        <Swiper
            // effect={'coverflow'}
            slidesPerView={'1'}
            watchSlidesVisibility={true}
            pagination={{
                clickable: true
            }}
            loop={true}
            navigation={{
                enabled: true,
            }}
            autoplay={{
                "delay": 2500,
                "pauseOnMouseEnter": true,
                "disableOnInteraction": false
            }}
            className="video-swiper box-shadow-danger"
            // styleName="video-swiper"
        >
            {
                videos.map(video => {
                    if (video.featuredAt) {
                        return (
                            <SwiperSlide key={`key_${video._id}`}>
                                <VideoBlock video={video} />
                            </SwiperSlide>
                        )
                    }
                })
            }
            {/* <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide> */}
        </Swiper> : null
    )
}

export default VideoGallery;